import { find } from "lodash";

export const typeList = [
  { id: "from_school", name: "From School", color: "#00bcd4" },
  { id: "to_school", name: "To School", color: "#40c4ff" },
  { id: "cca", name: "CCA", color: "#2a9df4" },
];

export const schoolTimeLabel = (type: string) => {
  switch (type) {
    case "ToSchool":
      return "School Start Time";
    case "FromSchool":
      return "School End Time";
    case "Cca":
      return "Cca End Time";

    default:
      break;
  }
};

export const arrivalTimeLabel = (type: string) => {
  switch (type) {
    case "ToSchool":
      return "Bus Arrive by";
    case "FromSchool":
    case "Cca":
      return "Bus Leave by";

    default:
      break;
  }
};

export const getBusScheduleType = (type: string) => {
  const findText = find(typeList, ["id", type]);

  return findText.name.toUpperCase();
};

export const getBusScheduleDays = (busSchedule: IBusSchedule) => {
  let days: string = "";

  if (busSchedule.isMonday) {
    days = days + " M,";
  }
  if (busSchedule.isTuesday) {
    days = days + " T,";
  }
  if (busSchedule.isWednesday) {
    days = days + " W,";
  }
  if (busSchedule.isThursday) {
    days = days + " TH,";
  }
  if (busSchedule.isFriday) {
    days = days + " F,";
  }

  return days.replace(/,(?=[^,]*$)/, "");
};
